export default __webpack_public_path__ + "static/contacts-afaabd5ba49979b1d3a5a27b6485c17b.png";